import React from 'react'
import Icon from '@mdi/react'
import { mdiLoading } from '@mdi/js'

export default function LoadingOverlay() {
  return (
    <div
      role="status"
      aria-label="Loading results"
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: 'rgba(255,255,255,0.7)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10,
      }}>
      <Icon path={mdiLoading} spin color="blue" size={3} aria-hidden={true} />
      <div
        style={{
          marginTop: 16,
          fontSize: 18,
          color: '#333',
          textAlign: 'center',
        }}>
        Loading results. This can take a while
      </div>
    </div>
  )
}
